// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

export default class ImageParallax extends WebComponent {
  constructor(props) {
    super(props);
    this.handleScroll = this.handleScroll.bind(this);
    this.animate = this.animate.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }

  didMount() {
    window.addEventListener('scroll', this.handleScroll);
    this.timeout = null;
    this.image = document.querySelector('.promo-lp-hero__image');
    this.imageWrapper = document.querySelector('.promo-lp-hero');
    this.offset = 0;
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  }

  handleScroll = () => {
    if (this.imageWrapper) {
      const imageHeight = this.imageWrapper.offsetHeight;
      const headerHeight = document.querySelector('.promo-lp-header').offsetHeight;

      if (window.scrollY < imageHeight + headerHeight) {
        window.requestAnimationFrame(() => this.animate((window.scrollY * 0.5) - this.offset));
      }
    }
  };

  animate = (shift) => {
    this.image.style.transform = `translate3d(0px, ${shift}px, 0px)`;
  };

  handleResize = () => {
    /*if (window.innerWidth < 1280 && window.innerWidth >= 768) {
      this.offset = 80;
    } else if (window.innerWidth < 768) {
      this.offset = 10;
    } else {
      this.offset = 150;
    }*/
  };

  willUnMount() {}
  update() {}
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/promoLP/ImageParallax.js